import React from 'react'
import { useNavigate } from 'react-router-dom'
import Card from './Card/Card'
import './index.css'
import { useCurrentUser } from '../../hooks/useCurrentUser';

export default function LoanCards({ handleLoanTypeForm, clientId }) {
  const decode = useCurrentUser();
  const navigate = useNavigate()
  const restrictedRoles = ['institute_user', 'institute_admin', 'channel_user'];
  const isRestricted = restrictedRoles.includes(decode?.role);

  return (
    <>
      <div className='l-c-container'>
        {clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? (
          <>
            <Card loanType='Education Loan' handleLoanTypeForm={handleLoanTypeForm} />
            {!isRestricted && <Card loanType='Mortgage Loan' handleLoanTypeForm={handleLoanTypeForm} />}
            {!isRestricted && <Card loanType='Business Loan' handleLoanTypeForm={handleLoanTypeForm} />}
            {!isRestricted && <Card loanType='Personal Loan' handleLoanTypeForm={handleLoanTypeForm} />}
            {!isRestricted && <Card loanType='Loan Against Securities' handleLoanTypeForm={handleLoanTypeForm} />}
            {['cra', 'crm', 'admin', 'crsa', 'institute_user', 'institute_admin'].includes(decode?.role) && (
              <Card loanType='Eligibility' onClick={() => navigate('/eligibility')} subtitle='Check Now →' />
            )}
          </>
        ) : (
          <Card loanType='Consumer Loan' handleLoanTypeForm={handleLoanTypeForm} />
        )}

        {clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (
          <>
            <Card loanType='Personal Loan' handleLoanTypeForm={handleLoanTypeForm} />
            <Card loanType='Vehicle Loan' handleLoanTypeForm={handleLoanTypeForm} />
          </>
        )}
      </div>

      {clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (
        <div className='l-c-container'>
          <Card loanType='Mortgage Loan' handleLoanTypeForm={handleLoanTypeForm} />
          <Card loanType='Term Loan' handleLoanTypeForm={handleLoanTypeForm} />
        </div>
      )}
    </>
  )
}
